import React from "react";
import jwt from "../utils/jwt";

/**
 * Render an HTML object to display the rank in the waiting line which is decreasing with the time. 
 * @param text : text translated which is displayed before the rank
 * @param token: token decoded
 * @param {} param0 
 */
export default function NeoRank({ token, wording, rank, next=2 }) {
    let [currentRank, setCurrentRank] = React.useState(null);
    let [oldRank, setOldRank] = React.useState(null);
    let [newRank, setNewRank] = React.useState(null);
    let [descInterval, setDescInterval] = React.useState(null);

    React.useEffect(() => {
        if (token) {
            let tokenParsed = jwt.parse(token);
            let { access, nbf: notBefore, iat: issuedAt } = tokenParsed.payload;

            // get the time before the new call
            let waitTime = (notBefore - issuedAt) * 1000;
            if (access) {
                waitTime = Math.max(1000, (notBefore - issuedAt) * 1000);
            };
            if (!oldRank) {
                setNewRank(rank);
                setOldRank(rank);
                setCurrentRank(rank);
                setDescInterval(0);
            } else {
                if (newRank === rank) {
                    setDescInterval(0);
                } else {
                    let interval = parseInt(waitTime / (newRank - rank));
                    setDescInterval(interval);
                };
                setCurrentRank(newRank);
                setOldRank(newRank);
                setNewRank(rank);
            };
        }
    }, [ token, rank, newRank, oldRank ]);

    /**
     * Function to decrease Timer each 1 sec
     */
    const descRank = React.useCallback(() => {
        let rank = currentRank - 1;
        if (rank <= newRank) {
            rank = newRank;
        };
        setCurrentRank(rank);
    }, [currentRank, newRank]);


    React.useEffect(() => {
        let timer = null;
        if (currentRank > newRank) {
            timer = setTimeout(() => descRank(), descInterval);
        };

        return () => clearTimeout(timer);
    }, [currentRank, descInterval, descRank, newRank]);

    const { waiting_rank, next_in_line, position } = wording;

    if (!rank) {
        return (
            <div className="queue-rank" >
                {waiting_rank}
            </div>
        );
    };

    if(rank < next) {
        return (
            <div className="queue-rank" >
                <span>{next_in_line}</span>
            </div>
        );
    }

    return (
        <div className="queue-rank" >
            <span>{position}</span> <span className='queue-rank-number'>{rank}</span>
        </div>
    );
}
